import styled from 'styled-components';
import Link from './Link';

export default styled(Link)`
	text-decoration: none;
	border: 1px solid ${props => props.theme.primaryColor};
	padding: 10px 15px;
	font-weight: 500;
	transition: background-color 0.3s, color 0.3s, border-color 0.3s;
	pointer-events: ${props => props.active && 'none'};
	background-color: ${props => props.active && props.theme.primaryColor};
	color: ${props => props.active && '#fff'};
	font-size: ${props => props.small && '14px'};

	&:hover {
		background-color: ${props => props.theme.primaryColor};
		color: #fff;
	}
`;
